import { Link } from "react-router-dom";
import { Users } from "lucide-react";
import { MOST_LOVED } from "@/data/content";
import { resolveAssetPath } from "@/lib/assets";

export const MostLovedSection = () => {
  return (
    <section
      id="packages"
      data-testid="most-loved-section"
      className="bg-[var(--soft)] pb-10"
    >
      <div className="max-w-[1280px] mx-auto px-4 lg:px-6 grid grid-cols-1 lg:grid-cols-12 gap-5">
        {/* Corporate Tours panel (left) */}
        <aside className="lg:col-span-4 bg-[var(--navy)] text-white rounded-xl overflow-hidden flex flex-col shadow-lg">
          <div className="p-5">
            <h3 className="font-serif-display text-2xl font-bold leading-tight">
              Corporate
              <br />
              <span className="text-[var(--yellow)]">Tours (MICE)</span>
            </h3>
            <p className="text-sm text-white/80 mt-3 leading-snug">
              End-to-end travel
              <br />
              for your teams,
              <br />
              clients & partners.
            </p>
          </div>
          <div className="px-5">
            <img
              src={resolveAssetPath("/assets/media/018-images-unsplash-com-photo-1522071820081-009f0129c71c.jpg")}
              alt="Corporate team off-site"
              className="w-full h-44 object-cover rounded-md"
            />
          </div>
          <div className="px-5 py-4 bg-[#0a1d3a]">
            <div className="bg-[var(--yellow)] text-[var(--navy)] text-[11px] font-bold text-center py-2 rounded">
              Plan Your Corporate Tour
              <div className="text-[10px] font-medium text-[#0b2545]/70 mt-0.5">
                Trusted by 80+ corporates
              </div>
            </div>
          </div>
        </aside>

        {/* Most loved grid */}
        <div className="lg:col-span-8 bg-[#fff8e7] rounded-xl p-5 md:p-7 shadow-sm">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-9 h-9 rounded-full bg-[var(--yellow)] flex items-center justify-center">
              <Users className="w-4 h-4 text-[var(--navy)]" />
            </div>
            <div>
            <h2 className="font-serif-display font-semibold text-[var(--navy)] text-2xl md:text-3xl">
                Most Loved by Our Guests
              </h2>
              <p className="text-xs text-gray-600">
                1,25,689 guests have travelled so far.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {MOST_LOVED.map((p, i) => (
              <Link
                to={`/search?q=${encodeURIComponent(p.title)}`}
                key={p.title}
                data-testid={`loved-card-${i}`}
                className="group relative rounded-lg overflow-hidden aspect-[5/4] block shadow-sm hover:shadow-xl transition-shadow"
              >
                <img
                  src={resolveAssetPath(p.image)}
                  alt={p.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                <div className="absolute inset-x-0 top-0 p-2.5">
                  <div className="text-[10px] text-white/80">From</div>
                  <div className="font-bold text-white text-sm leading-tight">
                    {p.from}
                  </div>
                </div>
                <div className="absolute inset-x-0 bottom-0 p-2.5">
                  <div className="text-white font-bold text-[13px] leading-tight">
                    {p.title}
                  </div>
                  <div className="text-[10px] text-white/85 mt-0.5">
                    {p.guests}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
